import { browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { useWebAuthn } from "../../../hooks/useWebAuthn";
import { AppDispatch } from "../../../store";

export const useEasyLogin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { registration } = useWebAuthn();
  const { state } = useLocation();
  const { accessToken } = state ?? {};

  useEffect(() => {
    if (!accessToken) return navigateToPage(PageRoutes.LOGIN);
    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["accessToken"],
      accessToken,
    );
    if (!browserSupportsWebAuthn()) {
      dispatch(
        appActions.showModal({
          title: "このブラウザはパスキーに対応していません",
          buttons: [],
          onDefaultCloseModal: () => {
            dispatch(authActions.setIsLoggedIn(true));
            navigateToPage(PageRoutes.HOME);
          },
        }),
      );
    }
  }, [accessToken]);

  const handleEasyLogin = useCallback(() => {
    dispatch(appActions.showLoading());

    dispatch(
      authActions.challengePasskeyRegister.started({
        onSuccess: async (payload) => {
          try {
            dispatch(appActions.showLoading());
            const result = await registration(payload);
            const response = result.response;
            dispatch(
              authActions.registerPasskey.started({
                passkey_token: payload.passkey_token,
                credential: {
                  id: result.id,
                  type: result.type,
                  raw_id: result.rawId,
                  response: {
                    attestation_object: response.attestationObject,
                    client_data_json: response.clientDataJSON,
                    authenticator_data: response.authenticatorData,
                    public_key: response.publicKey,
                    transports: response.transports,
                  },
                  authenticator_attachment: result.authenticatorAttachment,
                },
                onComplete: () => dispatch(appActions.hideLoading()),
                onSuccess: ({ success }) => {
                  if (!success)
                    dispatch(
                      appActions.showModal({
                        title: "パスキーを設定できませんでした",
                        buttons: [],
                      }),
                    );
                  else
                    navigateToPage(PageRoutes.PASSKEY_SETTING_COMPLETE, false, {
                      accessToken,
                    });
                },
              }),
            );
          } catch (error) {
            dispatch(appActions.hideLoading());
            dispatch(
              appActions.showModal({
                title: "パスキーを設定できませんでした",
                buttons: [],
              }),
            );
          }
        },
      }),
    );
  }, []);

  const handleSettingLater = useCallback(() => {
    dispatch(authActions.setIsLoggedIn(true));
  }, []);

  return { handleEasyLogin, handleSettingLater };
};
